// HK Tuning B2B — Global versiyon numarası
// Yeni sürüm çıkarmak için sadece bu değeri güncelleyin. Tüm arayüzde otomatik yansır.
export const APP_VERSION = "1.1.8";
